/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12.5 15V9L10 11.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 20H16.2C17.8802 20 18.7202 20 19.362 19.673C19.9265 19.3854 20.3854 18.9265 20.673 18.362C21 17.7202 21 16.8802 21 15.2V14M3 20L6 17M3 20L6 23M21 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V10M21 4L18 1M21 4L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3 8.8C3 7.11984 3 6.27976 3.32698 5.63803C3.6146 5.07354 4.07354 4.6146 4.63803 4.32698C5.27976 4 6.11984 4 7.8 4H21V15.2C21 16.8802 21 17.7202 20.673 18.362C20.3854 18.9265 19.9265 19.3854 19.362 19.673C18.7202 20 17.8802 20 16.2 20H3V8.8Z"
				fill="currentColor"
			/>
			<path
				d="M12.5 15V9L10 11.5M3 20H16.2C17.8802 20 18.7202 20 19.362 19.673C19.9265 19.3854 20.3854 18.9265 20.673 18.362C21 17.7202 21 16.8802 21 15.2V14M3 20L6 17M3 20L6 23M21 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V10M21 4L18 1M21 4L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM16.0303 4.96967C15.7374 4.67678 15.2626 4.67678 14.9697 4.96967C14.6768 5.26256 14.6768 5.73744 14.9697 6.03033L15.1893 6.25H9.5L9.42672 6.24998C9.034 6.24978 8.73101 6.24963 8.4635 6.30284C7.3726 6.51983 6.51983 7.3726 6.30284 8.4635C6.24963 8.73101 6.24978 9.034 6.24998 9.42672L6.25 9.5V10C6.25 10.4142 6.58579 10.75 7 10.75C7.41421 10.75 7.75 10.4142 7.75 10V9.5C7.75 8.9994 7.75363 8.85862 7.77402 8.75614C7.87265 8.26027 8.26027 7.87265 8.75614 7.77402C8.85862 7.75363 8.9994 7.75 9.5 7.75H15.1893L14.9697 7.96967C14.6768 8.26256 14.6768 8.73744 14.9697 9.03033C15.2626 9.32322 15.7374 9.32322 16.0303 9.03033L17.5303 7.53033C17.8232 7.23744 17.8232 6.76256 17.5303 6.46967L16.0303 4.96967ZM13.25 10C13.25 9.69665 13.0673 9.42318 12.787 9.30709C12.5068 9.191 12.1842 9.25517 11.9697 9.46967L10.4697 10.9697C10.1768 11.2626 10.1768 11.7374 10.4697 12.0303C10.7626 12.3232 11.2374 12.3232 11.5303 12.0303L11.75 11.8107V14C11.75 14.4142 12.0858 14.75 12.5 14.75C12.9142 14.75 13.25 14.4142 13.25 14V10ZM16.25 14V14.5C16.25 15.0006 16.2464 15.1414 16.226 15.2439C16.1273 15.7397 15.7397 16.1273 15.2439 16.226C15.1414 16.2464 15.0006 16.25 14.5 16.25H8.81066L9.03033 16.0303C9.32322 15.7374 9.32322 15.2626 9.03033 14.9697C8.73744 14.6768 8.26256 14.6768 7.96967 14.9697L6.46967 16.4697C6.17678 16.7626 6.17678 17.2374 6.46967 17.5303L7.96967 19.0303C8.26256 19.3232 8.73744 19.3232 9.03033 19.0303C9.32322 18.7374 9.32322 18.2626 9.03033 17.9697L8.81066 17.75H14.5L14.5733 17.75C14.966 17.7502 15.269 17.7504 15.5365 17.6972C16.6274 17.4802 17.4802 16.6274 17.6972 15.5365C17.7504 15.269 17.7502 14.966 17.75 14.5733L17.75 14.5V14C17.75 13.5858 17.4142 13.25 17 13.25C16.5858 13.25 16.25 13.5858 16.25 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 20L6 17M3 20L6 23M3 20H10M21 14V15.2C21 16.8801 21 17.7202 20.673 18.3619C20.3854 18.9264 19.9265 19.3854 19.362 19.673C18.7202 20 17.8802 20 16.2 20H14M21 3.99997L18 0.999969M21 3.99997L18 6.99997M21 3.99997H14M3 9.99997V8.79997C3 7.11981 3 6.27973 3.32698 5.638C3.6146 5.07351 4.07354 4.61457 4.63803 4.32695C5.27976 3.99997 6.11984 3.99997 7.8 3.99997H10M12.5 15V8.99997L10 11.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.5 15V9L10 11.5M3 20H16.2C17.8802 20 18.7202 20 19.362 19.673C19.9265 19.3854 20.3854 18.9265 20.673 18.362C21 17.7202 21 16.8802 21 15.2V14M3 20L6 17M3 20L6 23M21 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V10M21 4L18 1M21 4L18 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.9697 4.96967C15.2626 4.67678 15.7375 4.67678 16.0304 4.96967L17.5304 6.46967C17.8233 6.76256 17.8233 7.23744 17.5304 7.53033L16.0304 9.03033C15.7375 9.32322 15.2626 9.32322 14.9697 9.03033C14.6768 8.73744 14.6768 8.26256 14.9697 7.96967L15.1894 7.75H9.50005C8.99944 7.75 8.85867 7.75363 8.75618 7.77402C8.26032 7.87265 7.8727 8.26027 7.77407 8.75614C7.75368 8.85862 7.75005 8.9994 7.75005 9.5V10C7.75005 10.4142 7.41426 10.75 7.00005 10.75C6.58583 10.75 6.25005 10.4142 6.25005 10V9.5C6.25005 9.47523 6.25004 9.45081 6.25002 9.42672C6.24983 9.034 6.24968 8.73101 6.30289 8.4635C6.51988 7.3726 7.37265 6.51983 8.46355 6.30284C8.73105 6.24963 9.03405 6.24978 9.42677 6.24998C9.45086 6.24999 9.47528 6.25 9.50005 6.25H15.1894L14.9697 6.03033C14.6768 5.73744 14.6768 5.26256 14.9697 4.96967ZM12.7871 9.30709C13.0673 9.42318 13.25 9.69665 13.25 10V14C13.25 14.4142 12.9143 14.75 12.5 14.75C12.0858 14.75 11.75 14.4142 11.75 14V11.8107L11.5304 12.0303C11.2375 12.3232 10.7626 12.3232 10.4697 12.0303C10.1768 11.7374 10.1768 11.2626 10.4697 10.9697L11.9697 9.46967C12.1842 9.25517 12.5068 9.191 12.7871 9.30709ZM16.25 14.5V14C16.25 13.5858 16.5858 13.25 17 13.25C17.4143 13.25 17.75 13.5858 17.75 14V14.5C17.75 14.5248 17.7501 14.5492 17.7501 14.5733C17.7503 14.966 17.7504 15.269 17.6972 15.5365C17.4802 16.6274 16.6274 17.4802 15.5365 17.6972C15.269 17.7504 14.966 17.7502 14.5733 17.75C14.5492 17.75 14.5248 17.75 14.5 17.75H8.81071L9.03038 17.9697C9.32327 18.2626 9.32327 18.7374 9.03038 19.0303C8.73748 19.3232 8.26261 19.3232 7.96972 19.0303L6.46972 17.5303C6.17682 17.2374 6.17682 16.7626 6.46972 16.4697L7.96972 14.9697C8.26261 14.6768 8.73748 14.6768 9.03038 14.9697C9.32327 15.2626 9.32327 15.7374 9.03038 16.0303L8.81071 16.25H14.5C15.0007 16.25 15.1414 16.2464 15.2439 16.226C15.7398 16.1273 16.1274 15.7397 16.226 15.2439C16.2464 15.1414 16.25 15.0006 16.25 14.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
